'use strict';

module.exports = {
	'Array_isArray': window.Array.isArray
};